/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import { createApp, h } from "vue";
import _ from 'lodash'
window._ = _
import { createInertiaApp, router } from "@inertiajs/vue3";
import * as Sentry from '@sentry/vue';
import Translations from "./mixins/Translations";
import TranslateHelpers from "./mixins/TranslateHelpers";
import HasErrors from "./mixins/HasErrors";
import AppShell from "./layouts/AppShell.vue";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Check that #app exists before initialising Vue
if (document.getElementById('app')) {
    // Preserve hash targets after Inertia's default scroll reset
    router.on('navigate', () => {
        if (window.location.hash) {
            document.getElementById(window.location.hash.slice(1))?.scrollIntoView()
        }
    })

    createInertiaApp({
        resolve: (name) => import(`./pages/${name}`),
        setup({ el, App, props, plugin }) {
            const vueApp = createApp({
                render: () => h(AppShell, null, {
                    default: () => h(App, props),
                }),
            });

            // Only report browser errors from production builds
            if (process.env.NODE_ENV === 'production') {
                // https://docs.sentry.io/platforms/javascript/guides/vue/
                Sentry.init({
                    app: vueApp,
                    dsn: "https://3035a49377f468bf4434dca770f0a65a@o4510463708692480.ingest.de.sentry.io/4510463724683344",
                    // Mix/Webpack can strip optional chaining on window.SENTRY_RELEASE?.id —
                    // set release explicitly so init does not read that global.
                    release: 'nautique-members@' + (process.env.MIX_SENTRY_RELEASE || '1.0.0'),
                    dataCollection: {
                        // userInfo: false,
                        // httpBodies: [],
                    },
                });
            }

            vueApp
                .use(plugin)
                .mixin(HasErrors)
                .mixin(TranslateHelpers)
                .mixin(Translations)
                .mount(el);
        }
    });
}

// // Check for Service Worker support
// if ('serviceWorker' in navigator)
// {
//     console.info('Service worker good to go!');
//
//     //   Register the Service Worker
//     window.addEventListener("load", () => {
//         navigator.serviceWorker
//             .register("service-worker.js")
//             .then((register) => console.info("Service Worker: Registered"))
//             .catch((error) => console.error("Service Worker Error :", { error }));
//     });
// }

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
